import React, { useEffect, useState, useRef } from "react";
import { useData } from "../context/Context";

const TableModel = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const cancelRef = useRef();
  const { state, setState } = useData();

  const closeModal = () => setIsOpen(false);

  const handleDone = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      closeModal();
    }, 2000);
  };

  const handleTableChange = (e) => {
    setState((prev) => ({
      ...prev,
      selected_table: e.target.value,
    }));
  };

  return (
    <div>
      <div className="px-10 py-4">
        <h1 className="font-bold sm:text-[42px] text-[32px] text-[#FF9900]">
          3D Model Classification Tool
        </h1>
      </div>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div
            className="relative bg-black text-gray-300 border border-[#FF9900] rounded-xl p-6 max-w-sm w-full animate-fadeIn"
            role="dialog"
            aria-modal="true"
            aria-labelledby="dialog-title"
            ref={cancelRef}
          >
            <h3
              id="dialog-title"
              className="text-lg font-bold mb-4 text-[#FF9900]"
            >
              Select a Table Name
            </h3>
            <div className="mb-4">
              <select
                className="w-full p-2 rounded-md bg-gray-700 text-gray-300 border border-gray-600"
                id="table-select"
                value={state.selected_table || ""}
                onChange={handleTableChange}
              >
                <option value="">Select option</option>
                {state.tables?.map((table) => (
                  <option key={table} value={table}>
                    {table}
                  </option>
                ))}
              </select>
            </div>
            {/* <div className="flex justify-end gap-2">
              <button
                onClick={handleDone}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md transition-transform duration-300 hover:scale-110"
                disabled={isLoading}
              >
                {isLoading ? (
                  <span className="flex items-center">
                    <span className="loader mr-2"></span> Processing...
                  </span>
                ) : (
                  "Done"
                )}
              </button>
            </div> */}
          </div>
        </div>
      )}

      <style jsx>{`
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-in-out;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .loader {
          border: 2px solid transparent;
          border-top: 2px solid white;
          border-radius: 50%;
          width: 16px;
          height: 16px;
          animation: spin 0.7s linear infinite;
        }
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default TableModel;
